/**
 * Construit le titre d'une fiche en mode création.
 *
 * Tant qu'aucun libellé n'est saisi, on affiche le titre générique
 * (« Création d'un package »). Dès qu'un libellé est renseigné, il est ajouté
 * au titre (« Création d'un package : <libellé> »).
 */
const buildCreationTitle = (baseTitle: string, draftLabel?: string): string => {
    const trimmed = draftLabel?.trim();
    return trimmed ? `${baseTitle} : ${trimmed}` : baseTitle;
};

export default buildCreationTitle;
